import { serverSidePagePrepare } from "@lib/hooks"
import { ContactUsPage as PageComponent } from "@features/contact-us"

export const getServerSideProps = serverSidePagePrepare({
  callback: async ({ Models }) => {
    await Models.ContactUsModel.getContactUsPage()
  },
})

const ContactUsPage = () => {
  return <PageComponent />
}

export default ContactUsPage
